import {
    actionTypes,
    mutationTypes
} from 'BASE/store/types';
import chatUtil from 'BASE/common/chat/chat.util';
import chatConstant from 'BASE/common/chat/chat.constant';
import CONSTANT from 'BASE/common/chat/chat.constant'
import marquee_component from 'YD/views/Marquee'
import downloadCenter_component from 'YD/views/Home/DownloadCenter';
import switchUrl_component from 'YD/views/SpeedTest/SwitchUrl';
import GoExternalGame from 'BASE/components/externalGame/externalGame.go.component';
import ExternalGameConfig from 'BASE/components/externalGame/externalGame.config.component';
import * as gameMenu from 'BASE/common/menu/menu.game';
import lotteryConstant from 'BASE/common/lotteryConstant';
import Constant from 'BASE/common/lotteryConstant';
import enternalGameList from 'BASE/common/externalGame/externalGameList';
import topHeaderCollectionComponent from 'YD/views/TopHeader.Collection.vue';
import topHeaderCollectionEditComponent from 'YD/views/TopHeader.CollectionEdit.vue';
import slide_up_down from 'vue-slide-up-down';
import BaseChangeSkin from 'YD/components/bet/bet.component.changeSkin';
import LotteryMenu from 'YD/views/LotteryMenu.vue';
import FeedbackComponent from 'YD/views/Feedback.vue';
import { ActivityType } from 'BASE/common/activity/activity.constant.js';

import audiovisual from 'BASE/components/audiovisual/audiovisual.component';
export default {
    data: function () {
        return {
            activedTab: undefined,
            gameMenus: {},
            vrMenus: {},
            gameList: [],
            showTopMenu: true,
            showRightMenu: true,
            showOldIssues: false,
            foldRightMenu: false,
            activeHomeIcon: false,
            /** ��選彩票子選��後強制收合（避免仍 :hover 在 li�致選��不收） */
            lotteryDropSuppress: false,
        };
    },
    mixins: [GoExternalGame, audiovisual, BaseChangeSkin, ExternalGameConfig],
    computed: {
        gameDatas() {
            return this.$store.state.lottoinfo.data;
        },
        isAgent() {
            return this.$store.state.userinfo.isAgent;
        },
        isTransferPointEnabled() {
            return this.$store.state.userinfo.privileges.isTransferPointEnabled;
        },
        isSuperTransferPointEnabled() {
            return this.$store.state.userinfo.privileges.isSuperTransferPointEnabled;
        },
        userName() {
            return this.$store.state.userinfo.userName;
        },
        nickName() {
            return this.$store.state.userinfo.nickName;
        },
        playerName() {
            let playerName = this.nickName ? this.nickName : this.userName;
            return playerName;
        },
        walletAmount() {
            return this.$store.state.userinfo.walletAmount;
        },
        systemRoomUnreadCount() {
            if (this.$store.state.chat) {
                let _room = this.$store.state.chat.rooms.find((item) => item.type === CONSTANT.roomType.SYSTEM);
                if (_room)
                    return _room.unreadCount;
            }

            return 0;
        },
        customerServiceRoomUnreadCount() {
            if (this.$store.state.chat) {
                let _room = this.$store.state.chat.rooms.find((item) => item.type === CONSTANT.roomType.CUSTOMER_SERVICE);
                if (_room)
                    return _room.unreadCount;
            }

            return 0;
        },
        hideWalletAmount() {
            return this.$store.state.userinfo.hideWalletAmount;
        },
        audioMuted() {
            return this.$store.state.userinfo.audioMuted;
        },
        isDemoSite() {
            return this.$store.state.userinfo.IsDemoSite;
        },
        unreadAnnouncement() {
            const count = this.$store.state.userinfo.unreadAnnouncement
            if (count > 99) {
                return '99+';
            } else if (count > 0) {
                return count;
            } else {
                return '';
            }
        },
        HeadImage() {
            return this.$store.state.userinfo.headImage;
        },
        getLogoUrl() {
            try {
                let code = parseInt(this.HeadImage);
                if (!code)
                    return require('YD/assets/images/touxiang.jpg');

                return require('YD/assets/images/face' + code + '.jpg');
            } catch (e) {
                console.log(e);
                return;
            }
        },
        showHistoryNumbers() {
            return this.$store.state.bet && this.$store.state.bet.showOldIssues || false;
        },
        sportGames() {
            return this.getGamesByCategory('sport');
        },
        liveGames() {
            return this.getGamesByCategory('live');
        },
        slotGames() {
            return this.getGamesByCategory('slot');
        },
        cardGames() {
            return this.getGamesByCategory('card');
        },
        vipInfo() {
            return this.$store.state.userinfo.vipinfo;
        }
    },
    components: {
        marquee_component,
        downloadCenter_component,
        switchUrl_component,
        topHeaderCollectionComponent,
        topHeaderCollectionEditComponent,
        slide_up_down,
        'lottery-menu': LotteryMenu,
        feedback_component: FeedbackComponent,
    },
    methods: {
        clickTab(newTab) {
            if (newTab === this.activedTab) {
                this.closeTab();
                return;
            }
            this.activedTab = newTab;
        },
        closeTab() {
            this.activedTab = undefined;
        },
        async refreshAmount() {
            await this.$store.dispatch(actionTypes.USER_INFO_WALLET_AMOUNT);
        },
        openCustomerServiceChat() {
            if (this.$store.state.chat && this.$store.state.chat.userId) {
                let _roomId = chatUtil.getRoomId(chatConstant.serverRoomType.CUSTOMER_SERVICE, this.$store.state.chat.userId);
                this.$store.dispatch(actionTypes.CHAT_OPEN_ROOM_WINDOW, {
                    roomId: _roomId
                });
            }
        },
        openSystemChat() {
            if (this.$store.state.chat && this.$store.state.chat.userId) {
                let _roomId = chatUtil.getRoomId(chatConstant.serverRoomType.SYSTEM, this.$store.state.chat.userId);
                this.$store.dispatch(actionTypes.CHAT_OPEN_ROOM_WINDOW, {
                    roomId: _roomId
                });
            }
        },
        showAnnouncement(id, index) {
            if (this.$parent && this.$parent.showAnnouncement) {
                this.$parent.showAnnouncement(id, index);
            }
        },
        showDownloadCenter() {
            if (this.$refs && this.$refs.DownloadCenter) {
                this.$refs.DownloadCenter.showDownloadCenter();
            }
        },
        showSwitchUrl() {
            let _this = this;
            let _dialog = _this.$dialog.get('SwitchUrl');
            if (_this.$refs && _this.$refs.SwitchUrlRetest) {
                _this.$refs.SwitchUrlRetest.retest();
            }
            _dialog.show();

            _dialog.$on('close', function () {
                _dialog.hide();
            });
        },

        async switchCollectionEdit(enable) {
            if (this.$refs && this.$refs.CollectionEdit) {
                await this.$refs.CollectionEdit.UpdateCollection();
                this.$refs.CollectionEdit.display = enable;
            }
        },
        async updateCollection() {
            if (this.$refs && this.$refs.Collection) {
                await this.$refs.Collection.UpdateCollection();
            }
        },
        switchHideWalletAmount() {
            let _hideWalletAmount = !this.hideWalletAmount;
            this.$store.dispatch(actionTypes.USER_INFO_HIDE_WALLET_AMOUNT, {
                hideWalletAmount: _hideWalletAmount
            });
        },
        switchAudioMuted() {
            let _audioMuted = !this.audioMuted;
            this.$store.dispatch(actionTypes.USER_INFO_AUDIO_MUTED, {
                audioMuted: _audioMuted
            });
        },
        async getUserHeadImage() {
            let _this = this;
            try {
                let _result = await $.post("/api/AccountCenter/GetHeadImage");
                if (_result && _result.state) {
                    _this.$store.dispatch(actionTypes.USER_INFO_HEAD_IMAGE, {
                        headImage: _result.HeadImage
                    });
                }
            } catch (err) {
                console.error(err);
            }
        },
        switchOldIssues(value) {
            this.$store.commit(mutationTypes.BET_SHOW_OLD_ISSUES, value);
        },
        showFeedback() {
            let _dialog = this.$dialog.get('feedback');
            if (_dialog) {
                _dialog.show();
            }
        },
        async fetchGameConfig() {
            try {
                const gameConfigData = await this.getExternalGameConfig();
                if (gameConfigData) {
                    this.gameList = JSON.parse(JSON.stringify(enternalGameList));
                    for (const category of this.gameList) {
                        if (category.games && category.games.length > 0) {
                            for (const game of category.games) {
                                if (gameConfigData[game.type]) {
                                    const rawFrontEndType = gameConfigData[game.type].FrontEndType;
                                    let frontEndType;
                                    if (!isNaN(rawFrontEndType)) {
                                        frontEndType = parseInt(rawFrontEndType);
                                    } else if (Constant.FrontEndType[rawFrontEndType] !== undefined) {
                                        frontEndType = Constant.FrontEndType[rawFrontEndType];
                                    } else {
                                        frontEndType = Constant.FrontEndType.NONE;
                                    }
                                    game.hot = frontEndType === Constant.FrontEndType.HOT;
                                    game.new = frontEndType === Constant.FrontEndType.NEW;
                                }
                            }
                        }
                    }
                } else {
                    this.gameList = enternalGameList;
                }
            } catch (error) {
                console.error('獲取遊戲配置失敗:', error);
                this.gameList = enternalGameList;
            }
        },
        getGameImage(gameType) {
            const codeName = this.codeNameAry[gameType];
            try {
                return require(`YD/assets/images/header/game-${codeName}.png`);
            } catch (e) {
                return require('YD/assets/images/header/game-default.png');
            }
        },
        getGamesByCategory(category) {
            const found = this.gameList.find(c => c.category === category);
            return found ? found.games : [];
        },
        /** 每日宝箱、救援金：先打 ActivityList，有開則進對應活動頁，否則彈敬請期待 */
        async goToActivityByType(type) {
            try {
                const activityList = await $.post('/api/CJActivity/ActivityList');
                const activityTypes = (activityList || []).map(c => (c && c.Activity ? c.Activity.Type : c));
                const hasDailyTreasureChestMission = activityTypes.some(t => t === ActivityType.DailyTreasureChestMissionActivity);
                const hasReliefPackageActivity = activityTypes.some(t => t === ActivityType.ReliefPackageActivity);

                if (type === 'treasure') {
                    if (hasDailyTreasureChestMission) {
                        this.$router.push({ path: '/ActivityTreasure' });
                    } else {
                        this.$dialog.warning('敬请期待');
                    }
                } else if (type === 'rescue') {
                    if (hasReliefPackageActivity) {
                        this.$router.push({ path: '/ActivityRelief' });
                    } else {
                        this.$dialog.warning('敬请期待');
                    }
                }
            } catch (e) {
                this.$dialog.warning('敬请期待');
            }
        },
        onLotteryMenuSelect() {
            this.lotteryDropSuppress = true;
        },
        onLotteryNavLeave() {
            this.lotteryDropSuppress = false;
        },
    },
    updated() {
        //等所有Vue的資料更新完才做綁定，彩票遊戲選單是動態產生
        let _this = this;
        $(".topMenuItem").unbind().click(function () {
            _this.closeTab();
        });
    },
    async mounted() {
        try {
            this.gameMenus = await gameMenu.get();
            // 取得VR彩票
            this.vrMenus = await this.getVRLottery();
            await this.getUserHeadImage();
            await this.fetchGameConfig();
        } catch (err) {
            this.$dialog.warning('加载失败');
        }

        document.addEventListener('click', e => {
            if (!this.$el.contains(e.target)) {
                this.closeTab();
            }
        })
    },

    watch: {
        "$route.name": function (val, oldVal) {
            let _this = this;
            _this.showTopMenu = true;
            _this.showRightMenu = true;
            _this.activeHomeIcon = false;
            _this.showOldIssues = false;

            if (val == "DrawHistory" || val == "Register") {
                _this.showRightMenu = false;
            }
            if (val == "Bet") {
                _this.showOldIssues = true;
            }
            if (val == "Timeout" || val == "IPRestricted" || val == "ErrorMsg" || val == "LinkFailure" || val == "Offline") {
                _this.showTopMenu = false;
            }
            if (val == "Home") {
                _this.activeHomeIcon = true;
            }
        }
    }
};